import $ from "jquery";
import Shuffle from "shufflejs";



const $backgroundCover = $('<div class="menu-meganav-cover"></div>');

$(document).ready(function(){
    init_meganavs();

    $('body')
        .on('show.zf.dropdown', handle_meganav_show_event)
        .on('hide.zf.dropdown', handle_meganav_hide_event);
});

// //////////

function init_meganavs() {
    const megaNavs = document.querySelectorAll('.menu-meganav-contain');

    megaNavs.forEach((element) => {
        let suffleInstance = new Shuffle(element, {
            itemSelector: '.cell',
            speed: 0
        });

        $(element).data('cwSuffleInstance', suffleInstance);
    });
}

function handle_meganav_show_event(event) {
    const $element = $(event.target);

    if(!$element.hasClass('dropdown-pane')) {
        return;
    }

     if ($element.parentsUntil(".nav-main").length == 2) {
       $element
         .find(".menu-nav-contain .cell")
         .first()
         .find("h2")
         .trigger("click");
     }

    $backgroundCover.appendTo('body');
}

function handle_meganav_hide_event(event) {
    const $element = $(event.target);

    if(!$element.hasClass('dropdown-pane')) {
        return;
    }

    $backgroundCover.detach();
}


